module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators-3-w960.ec47f9b2.jpg";